<script>
import { mapGetters } from 'vuex'
import FormErrors from '@/components/forms/FormErrors'
import Roles from '@/mixins/Roles'
import _ from 'lodash'

export default {
    name: 'OrderForm',

    mixins: [Roles],

    props: {
        order: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            model: this.order,
            loading: false,
            penalty: {
                user_id: null,
                value: null,
                comment: null,
            },
            errors: new FormErrors(),
            addressSearch: null,
        }
    },

    computed: {
        ...mapGetters({
            orderTypes: 'orderTypes',
            drivers: 'usersDrivers',
            services: 'services',
            packets: 'packets',
            statuses: 'statuses',
        }),

        filteredOrderTypes() {
            if (this.order.service_id == 3) {
                return this.orderTypes.filter((x) => x.id == 2)
            }

            if (this.order.service_id == 4) {
                return this.orderTypes.filter((x) => x.id == 1)
            }
            return this.orderTypes
        },
    },

    mounted() {
        if (this.model.id) this.$store.dispatch('title', this.$t('ORDERS.EDIT'))
        else this.$store.dispatch('title', this.$t('ORDERS.CREATE'))
        this.fetchHosts()
    },

    methods: {
        save() {
            this.errors.forget()
            this.$store
                .dispatch('ordersSave', this.model)
                .then(() => {
                    this.$router.push({ name: 'home' })
                    this.loading = false
                })
                .catch((e) => {
                    if (e && e.errors) this.errors = e.errors
                    this.loading = false
                })
        },

        addAddress(model) {
            this.model.addresses.push(model)
        },

        delAddress(idx) {
            this.model.addresses.splice(idx, 1)
        },

        check: _.debounce(function (nosave) {
            if (this.loading) return
            this.loading = true
            this.errors.forget()
            this.$store
                .dispatch('ordersCheck', this.model)
                .then((res) => {
                    this.model.customer_user_id = res.customer_user_id
                    this.model.packet_id = res.packet_id
                    this.model.price = parseFloat(res.price)
                    this.model.price_driver = parseFloat(res.price_driver)
                    this.model.price_customer = parseFloat(res.price_customer)
                    this.model.price_crm = parseFloat(res.price_crm)
                    this.model.is_prepaid = res.is_prepaid
                    if (!nosave) this.save()
                    else this.loading = false
                })
                .catch((e) => {
                    if (e & e.errors) console.log(e)
                    this.loading = false
                })
        }, 1000),

        fetchHosts() {
            if (this.model.customer_company_id) {
                this.$store
                    .dispatch('companiesFetchUsers', {
                        company_id: this.model.customer_company_id,
                    })
                    .then((res) => {
                        this.hosts = res.data
                    })
            }
        },

        addPenalty() {
            this.$store
                .dispatch('ordersAddPenalty', {
                    oid: this.model.oid,
                    ...this.penalty,
                })
                .then(() => {
                    this.penalty.user_id = null
                    this.penalty.value = null
                    this.penalty.comment = null
                })
        },

        resetProvider() {
            if (this.model) {
                this.model.car_id = null
                this.model.provider_user_id = null
            }
        },

        resetCar() {
            if (this.model) {
                this.$set(this.model, 'car_id', null)
            }
            this.check(true)
        },
    },
}
</script>

<template lang="pug">
    div
        acrm-heading.mt-2(:level="5")
            | 1. {{ $t('ORDERS.CUSTOMER_DATA')}}
        .row
            .col-24.col-md-12
                acrm-company-selector(:disabled="!hasRoleUpdate('order.fields.customer_company_id')" v-model="model.customer_company_id" type="customer_own" first @input="check(true)") {{ $t('ORDERS.CUSTOMER_DATA_LABEL')}}
            .col-24.col-md-12(v-if="hasRoleView('order.fields.host_user_id')")
                acrm-company-user-selector(:disabled="!hasRoleUpdate('order.fields.host_user_id')" :companyId="model.customer_company_id" v-model="model.host_user_id")
                    template(v-if="model.service_id == 4") {{ $t('FILTER.DRIVER') }}
                    template(v-else) {{ $t('ADDRESSES.HOST') }}

        acrm-heading.mt-4(:level="5")
            | 2. {{ $t('ORDERS.PASSENGER_DATA')}}
        .row
            .col-24.col-md-6.col-xl-6
                acrm-input-line(:disabled="!hasRoleUpdate('order.fields.passenger_name')" v-model="model.passenger_name" :errorMsg="errors.get('passenger_name')") {{ $t('ORDERS.FIELDS.PASSENGER_NAME') }}
            .col-24.col-md-6.col-xl-6
                acrm-input-phone(:disabled="!hasRoleUpdate('order.fields.passenger_phone')" v-model="model.passenger_phone" :errorMsg="errors.get('passenger_phone')") {{ $t('ORDERS.FIELDS.PASSENGER_PHONE') }}
            .col-24.col-md-6.col-xl-6
                acrm-input-line(:disabled="!hasRoleUpdate('order.fields.passenger_email')" v-model="model.passenger_email" :errorMsg="errors.get('passenger_email')") {{ $t('ORDERS.FIELDS.PASSENGER_EMAIL') }}
            .col-24.col-md-6.col-xl-6(v-if="hasRoleView('order.fields.passenger_id')")
                acrm-input-line(:disabled="!hasRoleUpdate('order.fields.passenger_id')" v-model="model.passenger_id" :errorMsg="errors.get('passenger_id')") {{ $t('ORDERS.FIELDS.PASSENGER_ID') }}

        acrm-heading.mt-4(:level="5")
            | 3. {{ $t('ORDERS.TRANS_DATA')}}
        .row
            .col-24.col-md-8.col-xl(v-if="model.service_id != 3")
                acrm-multi-select(:disabled="!hasRoleUpdate('order.fields.passenger_number')" v-model="model.passenger_number" :options="['0','1','2','3','4','5','6','7','8']" :errorMsg="errors.get('passenger_number')" @input="check(true)") {{ $t('ORDERS.FIELDS.PASSENGER_NUMBER')}}
            .col-24.col-md-8.col-xl
                acrm-multi-select(:disabled="!hasRoleUpdate('order.fields.luggage_number')"  v-model="model.luggage_number" :options="['0','1','2','3','4','5','6','7','8']" :errorMsg="errors.get('luggage_number')") {{ $t('ORDERS.FIELDS.LUGGAGE_NUMBER')}}
            .col-24.col-md-8.col-xl
                acrm-multi-select(:disabled="!hasRoleUpdate('order.fields.carry_on_luggage_number')" v-model="model.carry_on_luggage_number" :options="['0','1','2','3','4','5','6','7','8']" :errorMsg="errors.get('carry_on_luggage_number')") {{ $t('ORDERS.FIELDS.CARRY_ON_LUGGAGE_NUMBER')}}
            .col-24.col-md-12.col-xl-8
                acrm-date-time-selector(:disabled="!hasRoleUpdate('order.fields.date')" v-model="model.date" :errorMsg="errors.get('date')")

            .col-24.col-md-12.col-xl-4(v-if="model.service_id != 3")
                acrm-multi-select(
                    :value="model.order_type_id"
                    @input="model.order_type_id = $event.id; check(true)"
                    track-by="id"
                    option-label="translated"
                    :options="filteredOrderTypes"
                    :multiple="false"
                    :errorMsg="errors.get('order_type_id')"
                    :disabled="!hasRoleUpdate('order.fields.order_type_id')"
                    ) {{ $t('ORDERS.FIELDS.ORDER_TYPE')}}

            .col-24.col-md-12.col-xl-4
                template(v-if="model.order_type_id == 1")
                    acrm-input-line(:disabled="!hasRoleUpdate('order.fields.flightnumber')" v-model="model.flightnumber" :errorMsg="errors.get('flightnumber')" ) {{ $t('ORDERS.FIELDS.FLIGHTNUMBER') }}

        template(v-if="model.service_id != 4")
            acrm-heading.mt-4.mb-2(:level="5")
                | 4. {{ $t('ORDERS.HOUSING_DATA')}}
            small
                router-link.mb-3.c-primary-2(:to="{name: 'addresses'}") {{ $t('ORDERS.ADDR_MANAGEMENT') }}
            .row.mb-4.mb-md-0
                .col-24.col-md-24
                    acrm-source-address-selector(
                        :disabled="!hasRoleUpdate('order.fields.addresses')"
                        :companyId="model.customer_company_id"
                        :def-object="model.source_address"
                        v-model="model.source_address_id"
                        :errorMsg="errors.get('source_address_id')")

            acrm-target-address-selector(
                v-if="model.service_id != 3"
                :disabled="!hasRoleUpdate('order.fields.addresses')"
                @input="addAddress"
                :companyId="model.customer_company_id"
            )

            acrm-heading.mt-4.c-dark-4(:level="6" bold v-if="model && model.addresses && model.addresses[0]")
                | {{ $t('ORDERS.ADD_ADDR')}}
            table.table.table-striped.table-hover(v-if="model && model.addresses && model.addresses[0]")
                thead
                    tr
                        th
                            .row
                                .col-1
                                    .label #
                                .col-12
                                    .label {{ $t('ORDERS.ADDR') }}
                                .col-11
                                    .label {{ $t('ORDERS.WELCOME') }}

                tbody
                    tr(v-for="(a,index) in model.addresses")
                        td
                            .row
                                .col-2.col-md-1
                                    strong.text-nowrap.c-dark-4 {{ index + 1 }}.
                                .col-20
                                    .flex-center-v(v-if="a.address")
                                        span.c-dark-4
                                            | {{ a.address }}
                                .col-2
                                    .flex-center-v.justify-content-end
                                        acrm-input-button.d-flex.float-right.btn-lg.p-0(v-if="hasRoleUpdate('order.fields.addresses')" variant="link" icon="close" @click="delAddress(index)")

        acrm-heading.mt-4.mb-2(:level="5")
            | 5. {{ $t('ORDERS.PROVIDER_DATA')}}
        .row.d-flex.flex-wrap.align-items-end
            .col-24.col-md-12(v-if="hasRoleView('order.fields.provider_company_id')")
                acrm-company-selector(
                    :disabled="!hasRoleUpdate('order.fields.provider_company_id')"
                    v-model="model.provider_company_id"
                    type="provider"
                    @input="check(true); resetProvider()") {{ $t('ORDERS.PROVIDER_LIST')}}
            .col-24.col-md-12.col-lg-7.col-xl-8
                template(v-if="hasRoleView('order.fields.provider_user_id')")
                    acrm-company-user-selector(:disabled="!hasRoleUpdate('order.fields.provider_user_id')" v-model="model.provider_user_id" :companyId="model.provider_company_id" @input="resetCar()")
                        template(v-if="model.service_id != 4") {{ $t('ORDERS.DRIVER_LIST')}}
                        template(v-else) {{ $t('ORDERS.TABLAZO_LIST')}}
                    acrm-input-car-select(
                        v-if="model.provider_user_id && model.service_id != 4"
                        v-model="model.car_id"
                        :driverId="model.provider_user_id"
                    ) {{ $t('CARS.CAR') }}
        template(v-if="hasRoleView('order.fields.comment') || hasRoleView('order.fields.admin_comment') || hasRoleView('order.fields.failed_comment') || hasRoleView('order.fields.driver_comment')")
            acrm-heading.mt-4.mb-2(:level="5")
                | 6. {{ $t('ORDERS.COMMENT')}}
            .row
                .col-24.col-md-12(v-if="hasRoleView('order.fields.comment')")
                    acrm-text-area(:rows="7" v-model="model.comment" :disabled="!hasRoleUpdate('order.fields.comment')")  {{ $t('ORDERS.COMMENT') }}
                .col-24.col-md-12(v-if="hasRoleUpdate('order.fields.admin_comment') || model.admin_comment != undefined")
                    acrm-text-area(:rows="7" v-model="model.admin_comment" :disabled="!hasRoleUpdate('order.fields.admin_comment')")  {{ $t('ORDERS.ADMIN_COMMENT') }}
                .col-24.col-md-12(v-if="hasRoleUpdate('order.fields.driver_comment') || model.driver_comment != undefined")
                    acrm-text-area(:rows="7" v-model="model.driver_comment" :disabled="!hasRoleUpdate('order.fields.driver_comment')")  {{ $t('ORDERS.DRIVER_COMMENT') }}
                .col-24.col-md-12(v-if="hasRoleUpdate('order.fields.failed_comment') || model.failed_comment != undefined")
                    acrm-text-area(:rows="7" v-model="model.failed_comment" :disabled="!hasRoleUpdate('order.fields.failed_comment')")  {{ $t('ORDERS.FAILED_COMMENT') }}

        acrm-heading.mt-4.mb-2(:level="5")
            | 7. {{ $t('ORDERS.ATTACHMENT')}}
        span {{ $t('ORDERS.MAX_FILE_SIZE')}}

        acrm-attachment-selector(v-model="model.attachments" :disabled="!hasRoleUpdate('order.fields.attachments')")

        acrm-heading.mt-4.mb-2(:level="5")
            | 8. {{ $t('FILTER.MODIFIERS')}}

        acrm-modifier-selector(v-model="model.modifiers" @input="check(true)" :disabled="!hasRoleUpdate('order.fields.modifiers')")

        acrm-heading.mt-4.mb-2(:level="5")
            | 9. {{ $t('ORDERS.LUGGAGE_AND_PRICE')}}
        .row.mb-3()
            .col-24.col-md-5
                acrm-multi-select(
                    :options="packets"
                    track-by="id"
                    option-label="name"
                    :value="model.packet_id"
                    :disabled="!hasRoleUpdate('order.fields.packet_id')"
                    @input="model.custom_packet_id = $event.id; check(true)"
                    ) {{ $t('ORDERS.LUGGAGE_LIST')}}
            .col-24.col-md-5

        table.table.table-striped.table-hover(v-if="hasRole('order.fields.price') || hasRole('order.fields.price_driver') || hasRole('order.fields.price_customer') || hasRole('order.fields.price_crm')")
            tbody
                tr(v-if="hasRoleView('order.fields.price') && ((model.is_prepaid && hasRoleUpdate('order.fields.price')) || !model.is_prepaid )")
                    td
                        .row
                            .col-6.flex-center-v {{ $t('ORDERS.PRICE_FULL')}}
                            .col-4.flex-center-v
                            .col-4.flex-center-v(v-if="model.custom_price == null") {{ model.price | toMoney }}
                            .col-12.col-sm-4.flex-center-v(v-else)
                                acrm-input-line(v-if="hasRoleUpdate('order.fields.price')" type="number" v-model="model.custom_price" @input="check(true)")
                            .col-8.flex-center-v
                                acrm-info(v-if="false") Az összeg módosítva lett.
                            .col-2.flex-center-v(v-if="hasRoleUpdate('order.fields.price')")
                                acrm-edit-button(icon="edit" v-if="model.custom_price == null" @click="model.custom_price = model.price")
                                acrm-edit-button(icon="remove" v-else @click="model.custom_price = null")
                tr(v-if="hasRoleView('order.fields.price_driver')")
                    td
                        .row
                            .col-6.flex-center-v {{ $t('ORDERS.PRICE_DRIVER')}}
                            .col-4.flex-center-v
                                template(v-if="false")
                                    acrm-avatar.d-inline-block(name="Pum Pál")
                                    acrm-input-button.ml-2.c-primary-2(variant="link") Pum Pál
                            .col-4.flex-center-v(v-if="model.custom_price_driver == null") {{ model.price_driver | toMoney }}
                            .col-12.col-sm-4.flex-center-v(v-else)
                                acrm-input-line(v-if="hasRoleUpdate('order.fields.price_driver')" type="number" v-model="model.custom_price_driver" @input="check(true)")
                            .col-8.flex-center-v
                                acrm-info(v-if="false") Az összeg módosítva lett.
                            .col-2.flex-center-v(v-if="hasRoleUpdate('order.fields.price_driver')")
                                acrm-edit-button(icon="edit" v-if="model.custom_price_driver == null" @click="model.custom_price_driver = model.price_driver")
                                acrm-edit-button(icon="remove" v-else @click="model.custom_price_driver = null")
                tr(v-if="hasRoleView('order.fields.price_customer')")
                    td
                        .row
                            .col-6.flex-center-v {{ $t('ORDERS.PRICE_PROVIDER')}}
                            .col-4.flex-center-v
                                template(v-if="false")
                                    acrm-avatar.d-inline-block(name="Pum Pál")
                                    acrm-input-button.ml-2.c-primary-2(variant="link") Pum Pál
                            .col-4.flex-center-v(v-if="model.custom_price_customer == null") {{ model.price_customer | toMoney }}
                            .col-12.col-sm-4.flex-center-v(v-else)
                                acrm-input-line(v-if="hasRoleUpdate('order.fields.price_customer')" type="number" v-model="model.custom_price_customer" @input="check(true)")
                            .col-8.flex-center-v
                                acrm-info(v-if="false") Az összeg módosítva lett.
                            .col-2.flex-center-v(v-if="hasRoleUpdate('order.fields.price_customer')")
                                acrm-edit-button(icon="edit" v-if="model.custom_price_customer == null" @click="model.custom_price_customer = model.price_customer")
                                acrm-edit-button(icon="remove" v-else @click="model.custom_price_customer = null")
                tr.not-editable(v-if="hasRoleView('order.fields.price_crm')")
                    td
                        .row
                            .col-6.flex-center-v {{ $t('ORDERS.PRICE_CRM')}}
                            .col-4.flex-center-v
                            .col-4.flex-center-v {{ model.price_crm | toMoney }}
                            .col-2.flex-center-v
                tr
                    td
                        .row
                            .col-6.flex-center-v {{ $t('ORDERS.PREPAID') }}
                            .col-4.flex-center-v
                            .col-4.flex-center-v
                                acrm-input-switch(v-model="model.is_prepaid" disabled v-if="model.custom_is_prepaid == null")
                                acrm-input-switch(v-model="model.custom_is_prepaid" v-else)
                            .col-8.flex-center-v
                            .col-2.flex-center-v(v-if="hasRoleUpdate('order.fields.is_prepaid')")
                                acrm-edit-button(icon="edit" v-if="model.custom_is_prepaid == null" @click="model.custom_is_prepaid = model.is_prepaid")
                                acrm-edit-button(icon="remove" v-else @click="model.custom_is_prepaid = null")

        template(v-if="hasRoleUpdate('order.penalty') && (order.order_status_id == 10 || order.order_status_id == 11 || order.order_status_id == 12)")
            acrm-heading.mt-4.mb-2(:level="5")
                strong {{ $t('ORDERS.PENALTY_TRANSACTION')}}

            .row.mb-4.penalty-container
                .col-6
                    acrm-input-user-select(v-model="penalty.user_id") {{ $t('USERS.USER') }}
                .col-6
                    acrm-input-line(type="number" v-model="penalty.value") {{ $t('ORDERS.PENALTY_VALUE') }}
                .col-8
                    acrm-input-line(v-model="penalty.comment") {{ $t('ORDERS.COMMENT') }}
                .col.mt-4
                    acrm-input-button(variant="primary" @click="addPenalty")
                        icon(name="add")
                        | {{ $t('ORDERS.ADD') }}

            acrm-heading(:level="5") {{ $t('ORDERS.TRANSACTIONS')}}

            table.table.table-striped.table-hover(v-if="model && model.transactions && model.transactions.length")
                thead
                    tr
                        th
                            .label {{ $t('ORDERS.TRANSACTION_ID')}}
                        th
                            .label {{ $t('ORDERS.TRANS_DATE') }}
                        th
                            .label {{ $t('ORDERS.COMMENT') }}
                        th
                            .label {{ $t('ORDERS.TRANSACTION_MEMBERS') }}
                        th
                            .label {{ $t('ORDERS.TRANSACTION_VALUE') }}

                tbody
                    tr(v-for="(t,index) in model.transactions")
                        td
                            strong.text-nowrap.c-dark-4 {{ t.id }}
                        td {{ t.created_at | toDateTime }}
                        td {{ t.comment }}
                        td
                            span.text-primary(v-if="t.from") {{ t.from.display_name }}
                            span.text-primary(v-else) CRM
                            span.text-bold &nbsp;-&gt;&nbsp;
                            span.text-primary(v-if="t.to") {{ t.to.display_name }}
                            span.text-primary(v-else) CRM
                        td {{ t.value | toMoney }}

        div.penalty-container(v-if="hasRoleUpdate('ordercard.status_set_all') && model.id")
            acrm-multi-select(
                :value="model.order_status_id_explicit"
                @input="model.order_status_id_explicit = $event.id"
                track-by="id"
                option-label="translated"
                :options="statuses"
                :multiple="false"
                :disabled="!hasRoleUpdate('ordercard.status_set_all')"
                )
                | {{ $t('ORDERS.ORDER_STATUS_MODIFY')}}
                span(v-if="model.order_status") &nbsp;({{ model.order_status.translated }})

        .text-right(v-if="false")
            acrm-input-button(variant="success" @click="check" :disabled="loading || (!hasRoleUpdate('orderlist.orders') && !hasRoleView('order.edit'))") {{ $t('BASE.SAVE') }}

        acrm-order-history(v-if="hasRole('order.fields.history') && order.history && order.history.length" :history="order.history")
</template>
<style lang="scss" scoped>
label {
    white-space: nowrap;
}
.penalty-container {
    padding-bottom: 20em;
}
</style>
